module.exports = "<ng-template [ngIf]=\"authService.isAuthenticated()\">\n    <app-header></app-header>\n</ng-template>\n<div class=\"container-fluid\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <router-outlet></router-outlet>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main